/* STREETSTYLE product page — ported from product.html's inline script.
   Add-to-cart now goes through Shopify's real cart (STREETSTYLE.addToCart
   from streetstyle-chrome.js) instead of the static demo's localStorage bag. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const METRO_PREFIXES = ['11', '40', '56', '60', '70', '50', '38', '41', '20', '12'];

  const form = $('#pdpForm');
  if (!form) return;

  /* ---- size selection ---- */
  let selectedVariant = $('#sizes .size[aria-pressed="true"]');
  $$('#sizes .size').forEach((b) => b.addEventListener('click', () => {
    $$('#sizes .size').forEach((x) => x.setAttribute('aria-pressed', 'false'));
    b.setAttribute('aria-pressed', 'true');
    selectedVariant = b;
    $('#selectedVariantId').value = b.dataset.variant;
    $('#sizeErr').hidden = true;
  }));

  /* ---- size guide ---- */
  const guideBtn = $('#guideBtn');
  if (guideBtn) {
    guideBtn.addEventListener('click', () => {
      const g = $('#guide'), open = g.hidden;
      g.hidden = !open;
      guideBtn.setAttribute('aria-expanded', String(open));
      guideBtn.textContent = open ? 'Hide size guide' : 'Size guide';
    });
  }

  /* ---- fit / delivery / returns dockets ---- */
  /* shares .docket__q with the FAQ section's own accordion script — guard
     against double-binding if both ever land on the same page. */
  $$('.docket__q').forEach((b) => {
    if (b.dataset.bound) return;
    b.dataset.bound = '1';
    b.addEventListener('click', () => {
      const panel = document.getElementById(b.getAttribute('aria-controls'));
      const open = panel.hidden;
      panel.hidden = !open;
      b.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---- pincode delivery estimate (illustrative, same as the static site) ---- */
  function checkPin(code) {
    if (!/^\d{6}$/.test(code)) return { ok: false, msg: 'Enter the 6-digit PIN code.' };
    const metro = METRO_PREFIXES.includes(code.slice(0, 2));
    const days = metro ? 2 : 5;
    const d = new Date(Date.now() + days * 864e5);
    const when = d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short' });
    return { ok: true, when, metro };
  }
  function runPin() {
    const v = $('#pin').value.trim();
    const r = checkPin(v);
    if (!r.ok) { $('#pinOut').innerHTML = `<p class="pin__err">${r.msg}</p>`; return; }
    $('#pinOut').innerHTML = `
      <p><span class="ok">Delivery by ${r.when}</span></p>
      <p style="margin-top:6px;color:var(--ink-3);font-size:13px">
        Cash on delivery available at ${v} &middot; ${r.metro ? 'Metro route' : 'Standard route'} &middot;
        Free shipping on this order</p>
      <p style="margin-top:6px;color:var(--ink-3);font-size:12px">Illustrative estimate.</p>`;
  }
  $('#pinBtn').addEventListener('click', runPin);
  $('#pin').addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); runPin(); } });

  /* ---- add to bag / buy now, real Shopify cart ---- */
  function addSelected(redirectToCheckout) {
    if (!selectedVariant) {
      $('#sizeErr').hidden = false;
      const first = $('#sizes .size:not(:disabled)');
      if (first) first.focus();
      $('#sizes').scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    const variantId = selectedVariant.dataset.variant;
    if (redirectToCheckout) {
      window.location.href = (window.Shopify ? window.Shopify.routes.root : '/') + 'cart/' + variantId + ':1';
      return;
    }
    window.STREETSTYLE.addToCart(variantId, 1);
  }
  $('#atc').addEventListener('click', (e) => { e.preventDefault(); addSelected(false); });
  $('#sAtc').addEventListener('click', () => addSelected(false));
  $('#buy').addEventListener('click', () => addSelected(true));

  /* ---- sticky add-to-bag bar once the main CTA scrolls out of view ---- */
  const sticky = $('#sticky');
  if (sticky && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([e]) => {
      sticky.classList.toggle('is-up', !e.isIntersecting);
    }, { rootMargin: '-140px 0px 0px 0px' });
    io.observe($('#atc'));
  }
})();
